import { handleActions } from 'redux-actions';
import { Actions } from 'actions/layoutActions';
import { Layout } from 'shared/models';
import { Dictionary, merge } from 'lodash';

export type State = {
    loaded: boolean;
    loading: boolean;
    data: Dictionary<Layout>;
    error: string | null;
};

export const initialState = Object.freeze<State>({
    loaded: false,
    loading: false,
    data: {},
    error: null,
});

export const layoutsReducer = handleActions({
    [Actions.GET_LAYOUTS_REQUEST]: state => {
        return {
            ...state,
            loaded: false,
            loading: true,
        };
    },
    [Actions.GET_LAYOUTS_SUCCESS]: (state, action: any) => {
        const layouts: readonly Layout[] = action.payload;
        return {
            loaded: true,
            loading: false,
            data: merge({}, state.data, ...layouts.map(b => ({ [b.id]: b }))),
            error: null,
        };
    },
    [Actions.GET_LAYOUTS_FAILURE]: (state, action: any) => {
        return {
            ...state,
            error: action.payload.message,
            loading: false,
        };
    },
}, initialState);
